export const languages = {
  SPANISH: 'es',
  ENGLISH: 'en',
  PORTUGUESE: 'pt'
}

export const languageList = [
  { id: 1, code: 'spanish', locale: 'es', default: true },
  { id: 2, code: 'english', locale: 'en', default: false },
  { id: 3, code: 'portuguese', locale: 'pt', default: false }
]

export const isValidLocale = (locale) => {
  return languageList.findIndex(el => el.locale === locale) > -1
}
